import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/contexts/MyContext";
import { Loader2 } from "lucide-react";
import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert";
import { useToast } from "@/components/ui/use-toast";
import { signUpWithEmail } from "@/hooks/useAuthentication";
import { supabase } from "@/lib/supabase";

const Signup = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  useEffect(()=>{
    (async()=>{
      const user =await supabase.auth.getUser();
      console.log(user);
      if(user.data.user){
        navigate("/dashboard");
      }
    })()
  },[])
  // const [debug, setDebug] = useState('');
  // const [showDebug, setShowDebug] = useState(false);
  const { signup } = useAuth();
  const navigate = useNavigate();
  // const { toast } = useToast();

  // useEffect(() => {
  //   const deletedEmailsStr = localStorage.getItem("deletedEmails");
  //   if (deletedEmailsStr) {
  //     try {
  //       const deletedEmails = JSON.parse(deletedEmailsStr);
  //       const debugMessage = `Deleted emails: ${deletedEmails.map((d: any) => d.email).join(', ')}`;

  //       if (deletedEmails.length > 0) {
  //         setDebug(debugMessage);
  //         setShowDebug(true);
  //       }
  //     } catch (e) {
  //       console.error("Error parsing deletedEmails:", e);
  //     }
  //   }
  // }, []);

  const validateForm = () => {
    if (!name || !email || !password || !confirmPassword) {
      setError("All fields are required");
      return false;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return false;
    }

    if (password.length < 6) {
      setError("Password must be at least 6 characters");
      return false;
    }

    return true;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
  setError("");
  setIsLoading(true);

  try {
    if (password !== confirmPassword) {
      throw new Error("Passwords do not match");
    }

    // const response = await signUpWithEmail({
    //   fullName: name,
    //   email,
    //   password,
    //   role: 'user',
    // });
    const response = await signup(name, email, password);

    navigate('/dashboard');
  } catch (error) {
    setError(error.message);
    console.error("Signup error:", error);
  } finally {
    setIsLoading(false);
  }
    // try {
    //   console.log(`Attempting signup with email: ${email}`);

    //   // Check for deleted emails
    //   const deletedEmailsStr = localStorage.getItem("deletedEmails");
    //   if (deletedEmailsStr) {
    //     try {
    //       const deletedEmails = JSON.parse(deletedEmailsStr);
    //       const normalizedEmail = email.toLowerCase().trim();
    //       const isDeleted = deletedEmails.some((d: any) =>
    //         d.email.toLowerCase() === normalizedEmail
    //       );

    //       console.log(`Email ${email} deleted status before signup: ${isDeleted}`);
    //       setDebug(`Email ${email} was previously deleted: ${isDeleted}`);

    //       if (isDeleted) {
    //         console.log("Note: This email was previously deleted but will be allowed to signup again");
    //       }
    //     } catch (e) {
    //       console.error("Error checking deleted status:", e);
    //     }
    //   }

    //   // Manual check for existing user directly in localStorage
    //   const currentUsersStr = localStorage.getItem("allUsers");
    //   const allUsers = currentUsersStr ? JSON.parse(currentUsersStr) : [];

    //   const existingUser = allUsers.find((u: any) =>
    //     u.email.toLowerCase() === email.toLowerCase().trim()
    //   );

    //   if (existingUser) {
    //     console.log(`Note: User with email ${email} already exists in users list`);
    //     setError('An account with this email already exists');
    //     setIsLoading(false);
    //     return;
    //   }

    //   // Create the user through the signup function
    //   await signup(name, email, password);

    //   // Verify the user was added by checking localStorage directly
    //   const newUserCheck = () => {
    //     const updatedUsersStr = localStorage.getItem("allUsers");

    //     if (updatedUsersStr) {
    //       const updatedUsers = JSON.parse(updatedUsersStr);
    //       console.log("Users after signup:", updatedUsers);

    //       // Verify the new user exists in the list
    //       const newUser = updatedUsers.find((u: any) =>
    //         u.email.toLowerCase() === email.toLowerCase().trim()
    //       );

    //       if (!newUser) {
    //         console.error("New user not found in user list after signup");

    //         // Create user directly as a fallback
    //         const fallbackUser = {
    //           id: Date.now().toString(),
    //           email: email.trim(),
    //           name: name.trim(),
    //           memberships: ['course'],
    //           locked: false,
    //           courseProgress: []
    //         };

    //         updatedUsers.push(fallbackUser);
    //         localStorage.setItem("allUsers", JSON.stringify(updatedUsers));
    //         console.log("Added user directly to localStorage as fallback");

    //         toast({
    //           title: "Account Created",
    //           description: "Your account has been created and added to the system.",
    //         });
    //       } else {
    //         console.log("New user successfully added to user list:", newUser);
    //         toast({
    //           title: "Account Created",
    //           description: "Your account has been created successfully. Welcome!",
    //         });
    //       }
    //     }
    //   };

    //   // Immediate check
    //   newUserCheck();

    //   // Extra verification after a short delay
    //   setTimeout(newUserCheck, 500);

    //   navigate('/dashboard');
    // } catch (err) {
    //   const errorMessage = err instanceof Error ? err.message : 'An error occurred during signup';
    //   setError(errorMessage);
    //   console.error("Signup error:", err);
    // } finally {
    //   setIsLoading(false);
    // }
  };

  return (
    <div className="flex flex-col min-h-[calc(100vh-4rem)] items-center justify-center py-12">
      <div className="w-full max-w-md space-y-8 p-8 bg-white rounded-lg shadow-md">
        <div className="text-left">
          <h1 className="text-2xl font-bold">Create an account</h1>
          <p className="mt-2 text-gray-600 text-left">
            Join us to get access to all our content
          </p>
        </div>

        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          {error && (
            <Alert variant="destructive">
              <AlertTitle>Signup Failed</AlertTitle>
              <AlertDescription>{error}</AlertDescription>
            </Alert>
          )}

          {/* {showDebug && (
            <Alert variant="default" className="bg-blue-50 border-blue-200">
              <AlertTitle>Debug Info</AlertTitle>
              <AlertDescription className="text-blue-700">{debug}</AlertDescription>
            </Alert>
          )} */}

          <div className="space-y-4">
            <div>
              <Label htmlFor="name" className="text-left block mb-2">
                Full Name
              </Label>
              <Input
                id="name"
                type="text"
                placeholder="John Doe"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                className="mt-1 text-left"
                autoComplete="name"
              />
            </div>

            <div>
              <Label htmlFor="email" className="text-left block mb-2">
                Email
              </Label>
              <Input
                id="email"
                type="email"
                placeholder="name@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-1 text-left"
                autoComplete="email"
              />
            </div>

            <div>
              <Label htmlFor="password" className="text-left block mb-2">
                Password
              </Label>
              <Input
                id="password"
                type="password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="mt-1 text-left"
                autoComplete="new-password"
              />
            </div>

            <div>
              <Label htmlFor="confirmPassword" className="text-left block mb-2">
                Confirm Password
              </Label>
              <Input
                id="confirmPassword"
                type="password"
                placeholder="••••••••"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                className="mt-1 text-left"
                autoComplete="new-password"
              />
            </div>
          </div>

          <div className="text-sm text-gray-600 text-left">
            By creating an account, you agree to our{" "}
            <Link
              to="/terms-of-service"
              className="font-medium text-brand-600 hover:text-brand-500"
            >
              Terms of Service
            </Link>{" "}
            and{" "}
            <Link
              to="/privacy-policy"
              className="font-medium text-brand-600 hover:text-brand-500"
            >
              Privacy Policy
            </Link>
            .
          </div>

          <Button
            type="submit"
            className="w-full text-left justify-center"
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Creating account...
              </>
            ) : (
              "Create Account"
            )}
          </Button>
        </form>

        <div className="mt-6 text-left">
          <p className="text-sm text-gray-600">
            Already have an account?{" "}
            <Link
              to="/login"
              className="font-medium text-brand-600 hover:text-brand-500"
            >
              Sign in
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Signup;
